import { useEffect } from 'react';

interface Options {
  onNew: () => void;
  onClose: () => void;
  onSwitchByIndex: (idx: number) => void;
}

export function usePosTabsHotkeys({ onNew, onClose, onSwitchByIndex }: Options): void {
  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if (document.querySelector('.ant-modal-wrap')) return;

      if (e.key === 'F1') {
        e.preventDefault();
        onNew();
        return;
      }
      if (e.key === 'F2') {
        e.preventDefault();
        onClose();
        return;
      }
      if (e.altKey && /^[0-9]$/.test(e.key)) {
        e.preventDefault();
        const n = parseInt(e.key, 10);
        const idx = n === 0 ? -1 : n - 1;
        onSwitchByIndex(idx);
      }
    };
    window.addEventListener('keydown', handler, { capture: true });
    return () => window.removeEventListener('keydown', handler, { capture: true });
  }, [onNew, onClose, onSwitchByIndex]);
}
